const foodCostCalculator = [
    {
        selector: '[data-react="foodCostCalculator"]',
        path: { filename: 'App' },
    },
];

export { foodCostCalculator };
